import { 
	WINDOW_RESIZED_EVENT,
	OPEN_MODAL,
	CLOSE_MODAL,
	ADJUST_UI_ON_PAGE_LOAD,
	COMPLETED_ADJUST_UI_ON_PAGE_LOAD
} from '../actions';

let findColNum = (): any[] => {
    let relevantWidth = window.innerWidth;
    if (document.body.clientWidth > window.innerWidth) {
      relevantWidth = document.body.clientWidth;
    }
    if (relevantWidth < 768) {
      return [1];
    } else if (relevantWidth < 992) {
      return [1, 2];
    } else {
      return [1, 2, 3];
    }
}

const windowState = (state = {picCols: [1, 2, 3], showBackdrop: false, showModal: false, adjustUIRequired: false}, action) => {
	switch (action.type) {
		case WINDOW_RESIZED_EVENT:
			let picCols = findColNum();
			return Object.assign({}, state, {
				picCols: picCols
			});
		case ADJUST_UI_ON_PAGE_LOAD:
			return Object.assign({}, state, {
				adjustUIRequired: true
			});
		case COMPLETED_ADJUST_UI_ON_PAGE_LOAD:
			return Object.assign({}, state, {
				adjustUIRequired: false
			});
		case OPEN_MODAL:
			if (state.showModal) {
				return state;
			}
			return Object.assign({}, state, {
				showModal: true,
				showBackdrop: true,
				modalPhotoUrl: action.photoUrl,
				modalPhotoTitle: action.photoTitle,
				modalComponent: action.modalComponent
			});
		case CLOSE_MODAL:
			if (!state.showModal) {
				return state;
			}
			return Object.assign({}, state, {
				showModal: false,
				showBackdrop: false,
			});
		default:
			return state;
	}
};

export { windowState };



/** WEBPACK FOOTER **
 ** ./src/flickr-redux/reducers/windowStateActionReducers.js
 **/